import { createContext, useContext } from 'react';
import { UnitsContext } from '../UnitsContext';

export const ConfigContext = createContext();

// We only store the raw config , the config obj in Overview.jsx is built from generateConfig function found in utilites/helpers.js
const ConfigProvider = ({ children }) => {
	const { curSelectedUnit, units, updateUnit } = useContext(UnitsContext);

	const rawConfig = units && units[curSelectedUnit] ? units[curSelectedUnit] : {};

	const updateRawConfig = (ObjOrCallBack) => {
		updateUnit(curSelectedUnit, ObjOrCallBack);
	};

	return (
		<ConfigContext.Provider
			value={{
				updateRawConfig,
				rawConfig
			}}
		>
			{children}
		</ConfigContext.Provider>
	);
};
export default ConfigProvider;
